import styled from 'styled-components';
import breakpoint from '../breakpoints';

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  height: 345px;
  background-color: #2f6eb4;
  ${breakpoint('mobile', 'down')}{
    height: 112px;
    > img {
      width: 100%;
    }
  }
`
export const Fingerprint = styled.div`
  position: absolute;
  top: 45%;
  right: 6%;
  width: 58vw;
  transform: translate3d(0, -50%, 0);
  img {
    color: #2e5b9e;
    width: 100%;
    display: block;
  }
`
export const FingerprintRight = styled.div`
  position: absolute;
  top: 45%;
  right: -19%;
  width: 58vw;
  transform:translate3d(0, -50%, 0);
  img {
    transform: rotate(180deg);
    width: 100%;
    display: block;
  }
`

export const ContentWrapper = styled.div`
  border-bottom: 1px solid #ccc;
  padding-bottom: 50px;
  width: 90%;
  margin: auto;
  ${breakpoint('mobile', 'down')}{
    width: 80%;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 60%;
  margin: auto;
  padding-top: 40px;
  & > span {
    text-align: center;
    ${({ie}) => {
      if (ie === "true") {return 'width: 100%;'}
    }}
  }
  ${breakpoint('tablet', 'down')} {
    width: 100%;
  }
`
export const Image = styled.div`
  display: block;
  position: relative;
  padding-top: calc(224/375 * 100%);

  ${breakpoint('tablet', 'up')} {
    padding-top: calc(666/1440 * 100%);
  }

  img {
    width: 100%;
    display: block;
    pointer-events: none;
    position: absolute;
    left: 0;
    top: 0;
  }
`
